import { render } from "./EmployeeDetailsExt.vue?vue&type=template&id=31cf82cc&scoped=true"
import script from "./EmployeeDetailsExt.vue?vue&type=script&lang=js"
export * from "./EmployeeDetailsExt.vue?vue&type=script&lang=js"

import "./EmployeeDetailsExt.vue?vue&type=style&index=0&id=31cf82cc&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31cf82cc"]])

export default __exports__